export const compressImage = (file, maxWidth = 1200, quality = 0.8) => {
  return new Promise((resolve, reject) => {
    const compressionId = Math.random().toString(36).substr(2, 6);
    console.log(`[COMPRESS ${compressionId}] Starting compression for:`, file.name, 'size:', file.size, 'lastModified:', file.lastModified);

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    const blobUrl = URL.createObjectURL(file);

    console.log(`[COMPRESS ${compressionId}] Created blob URL:`, blobUrl);

    img.onload = () => {
      console.log(`[COMPRESS ${compressionId}] Image loaded, dimensions:`, img.width, 'x', img.height);

      // Clean up blob URL immediately after load (memory leak fix)
      URL.revokeObjectURL(blobUrl);

      const ratio = Math.min(maxWidth / img.width, maxWidth / img.height);
      const newWidth = img.width * ratio;
      const newHeight = img.height * ratio;

      canvas.width = newWidth;
      canvas.height = newHeight;

      ctx.drawImage(img, 0, 0, newWidth, newHeight);

      canvas.toBlob((blob) => {
        if (blob) {
          console.log(`[COMPRESS ${compressionId}] Blob created, size:`, blob.size);
          resolve(blob);
        } else {
          console.error(`[COMPRESS ${compressionId}] toBlob returned null`);
          resolve(file); // Fallback to original file
        }
      }, 'image/jpeg', quality);
    };

    img.onerror = (err) => {
      console.error(`[COMPRESS ${compressionId}] Image load failed:`, err);
      URL.revokeObjectURL(blobUrl);
      resolve(file); // Fallback to original file
    };

    img.src = blobUrl;
  });
};

export const createThumbnail = (file, size = 300) => {
  return new Promise((resolve) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    
    img.onload = () => {
      canvas.width = size;
      canvas.height = size;
      
      const minDimension = Math.min(img.width, img.height);
      const x = (img.width - minDimension) / 2;
      const y = (img.height - minDimension) / 2;
      
      ctx.drawImage(img, x, y, minDimension, minDimension, 0, 0, size, size);
      
      canvas.toBlob(resolve, 'image/jpeg', 0.9);
    };
    
    img.src = URL.createObjectURL(file);
  });
};